/*********************** Preact *******************************/
import { connect } from "preact-redux";
/******************** Custom Components ***********************/
import Sankey from "./component";
/************************* Actions ****************************/
import { fetchBudgetFinancialFlow } from "./actions/budgetFinancialFlowActions";
import { fetchExpenseFinancialFlow } from "./actions/expenseFinancialFlowActions";
import {
  updateYearList,
  setCurrentYear,
} from "../../shared/actions/getYearList";
/**************************************************************/

const mapStateToProps = (state) => {
  const { loading, error, items } = state.sankeyData;
  const year = state.yearList.currentYear;
  return { loading, error, items, year, };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBudgetFinancialFlow: (year) =>
      dispatch(fetchBudgetFinancialFlow(year)),
    fetchExpenseFinancialFlow: (year) =>
      dispatch(fetchExpenseFinancialFlow(year)),
    setCurrentYear: (year) => dispatch(setCurrentYear(year)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sankey);



// WEBPACK FOOTER //
// ./components/sankey/index.js